export default "__VITE_ASSET__CzvLtzlD__"